import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SelectModule} from 'primeng/select';
import {SelectAutoDisplayFirstDirective} from '@app/directives/select-auto-display-first.directive';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {TagModule} from 'primeng/tag';
import {TooltipModule} from 'primeng/tooltip';
import {InputTextModule} from 'primeng/inputtext';
import {MenuModule} from 'primeng/menu';
import {SplitButtonModule} from 'primeng/splitbutton';
import {PrinterClientsDialogComponent} from './printer-clients-dialog.component';

@NgModule({
    declarations: [
        PrinterClientsDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        SelectModule,
        SelectAutoDisplayFirstDirective,
        DialogModule,
        ButtonModule,
        TagModule,
        TooltipModule,
        MenuModule,
        SplitButtonModule,
        InputTextModule
    ],
    exports: [
        PrinterClientsDialogComponent
    ]
})
export class SharedPrinterClientsModule { }
